import React from "react";

const InvestmentDriversItem = ({ item }) => {
  return (
    <div 
      className="investment-driver-item p-3 text-center shadow"
      style={{
        backgroundColor: "rgba(33, 37, 41, 0.4)",
        borderRadius: "25px",
        border: "1px solid rgba(255, 255, 255, 0.1)",
        minHeight: "220px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <div className="driver-icon mb-3" style={{ 
        fontSize: "1.5rem", 
        color: item.iconColor,
        width: "auto",
        height: "auto",
        background: "none",
        border: "none",
        borderRadius: "0"
      }}>
        {item.icon}
      </div>
      <div className="driver-content">
        <h3 className="title text-white mb-2" style={{ fontSize: "1.2rem", fontWeight: "bold" }}>
          {item.title}
        </h3>
        <p className="text-light" style={{ fontSize: "0.9rem", lineHeight: "1.5" }}>
          {item.description}
        </p>
      </div>
    </div>
  );
};

export default InvestmentDriversItem;
